import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  tr: {
    translation: {
      // Login screen
      login: {
        title: "Kral Kart Oyunu",
        subtitle: "Strateji krallığına girin",
        username: "Kullanıcı Adı",
        usernamePlaceholder: "Kullanıcı adınızı girin",
        roomName: "Oda Adı",
        roomPlaceholder: "Oda adını girin",
        singlePlayerMode: "Tek Oyuncu Modu",
        singlePlayerDescription: "Yapay zeka rakiplere karşı oyna",
        joinGame: "Oyuna Katıl",
        connecting: "Bağlanıyor...",
        gameRules: "Oyun Kuralları",
        // Authentication step
        chooseHowToContinue: "Nasıl devam etmek istediğinizi seçin",
        loginWithGoogle: "Google ile Giriş Yap",
        signingIn: "Giriş yapılıyor...",
        continueAsGuest: "Misafir olarak devam et",
        googleLoginSavesProgress: "Google girişi ilerlemenizi ve tercihlerinizi kaydeder",
        back: "← Geri",
        // Game mode selection
        singlePlayer: "🎮 Tek Oyuncu",
        multiplayer: "👥 Çok Oyunculu",
        // Room selection
        enterRoomName: "Katılmak veya oluşturmak için oda adı girin",
        enterRoomNamePlaceholder: "Oda adını girin",
        joining: "Katılıyor...",
        joinRoom: "Odaya Katıl",
        // Username modal
        chooseYourUsername: "Kullanıcı Adınızı Seçin",
        enterDisplayName: "Oyun için bir görünen ad girin",
        enterYourUsername: "Kullanıcı adınızı girin",
        cancel: "İptal",
        rules: {
          rule1: "• 4 oyuncu bu stratejik kart oyununda yarışır",
          rule2: "• Arkadaşlarla çok oyunculu veya yapay zeka ile tek oyuncu",
          rule3: "• Ellere teklif ver ve ceza kartlarından kaçın",
          rule4: "• \"Kral\" olmak ve oyunu bitirmek için 10+ el kazan",
          rule5: "• En yüksek puana sahip oyuncu kazanır"
        },
        debugInfo: "Hata Ayıklama Bilgisi",
        debugServerMessage: "Backend sunucusunun 8080 portunda çalıştığından emin olun",
        connectionStatus: {
          connecting: "Sunucuya bağlanıyor...",
          connected: "Bağlandı ✓",
          error: "Bağlantı başarısız ✗",
          disconnected: "Bağlantı kesildi"
        }
      },
      // Game Board
      game: {
        yourCards: "Kartlarınız",
        middleCards: "Ortadaki Kartlar",
        currentPlayer: "Şu anki oyuncu",
        waitingForOtherPlayers: "Diğer oyuncular bekleniyor",
        selectCard: "Kart seç",
        playCard: "Kartı oyna",
        yourTurn: "Sizin sıranız",
        gameEnded: "Oyun bitti",
        winner: "Kazanan",
        playerLeft: "Oyuncu ayrıldı",
        reconnecting: "Yeniden bağlanıyor...",
        cardsWillAppearHere: "Kartlar burada görünecek",
        whenPlayersMove: "oyuncular hamle yaptığında",
        yourTurnToPlay: "🎯 Kart oynama sıranız!",
        waitingForPlayer: "⏳ {playerName} oyuncusunun oynaması bekleniyor...",
        hiddenCard: "Gizli Kart"
      },
      // Score Board
      score: {
        title: "Skorlar",
        player: "Oyuncu",
        score: "Skor",
        round: "Tur",
        totalScore: "Toplam Skor",
        scoreboard: "Skor Tablosu",
        chooseYourHand: "Elinizi Seçin",
        previewAvailableHands: "Mevcut Elleri Önizle",
        currentHand: "Şu Anki El",
        positive: "pozitif",
        negative: "negatif",
        pts: "puan",
        noScoresYet: "Henüz skor yok",
        scoresWillAppear: "Skorlar oyun sırasında görünecek",
        totalPlayers: "Toplam Oyuncu",
        highestScore: "En Yüksek Skor"
      },
      // Available Hands
      hands: {
        title: "Mevcut Eller",
        selectHand: "El seç",
        noHands: "Mevcut el yok",
        bidding: "Teklif veriliyor",
        selectedHand: "Seçili el",
        waitingForTurn: "Sıranızı bekliyorsunuz",
        chooseHand: "El Seç",
        yourTurn: "Sizin sıranız",
        previewOnly: "Sadece önizleme",
        waitingForTurnDots: "Sıra bekleniyor...",
        availableHands: "Mevcut Eller",
        chooseYourHand: "🎯 Elinizi seçin!",
        noHandsAvailable: "Mevcut el yok",
        handsWillAppear: "Seçim zamanı geldiğinde eller görünecek",
        waitingForTurnToChoose: "⏳ Seçim sıranızı bekliyorsunuz",
        // Specific hand names
        handNames: {
          // Positive hands (tricks)
          "1_tricks": "1 El",
          "2_tricks": "2 El", 
          "3_tricks": "3 El",
          "4_tricks": "4 El",
          "5_tricks": "5 El",
          "6_tricks": "6 El",
          "7_tricks": "7 El",
          "8_tricks": "8 El",
          "9_tricks": "9 El",
          "10_tricks": "10 El",
          "11_tricks": "11 El",
          "12_tricks": "12 El",
          "13_tricks": "13 El",
          "king": "Kral",
          "kral": "Kral",
          // Punishment hands
          "rifki": "Rifki",
          "no_hands": "Elsiz",
          "no_men": "Erkeksiz", 
          "no_women": "Kadınsız",
          "no_hearts": "Kırmızısız",
          "no_tricks": "Ellersiz",
          "last_two": "Son İki El",
          // Card suits and values
          "CLUBS": "Koz Sinek",
          "DIAMONDS": "Koz Karo", 
          "HEARTS": "Koz Kupa",
          "SPADES": "Koz Maça",
          "clubs": "Sinek",
          "diamonds": "Karo",
          "hearts": "Kupa", 
          "spades": "Maça",
          // Additional card values that might appear
          "J": "J",
          "Q": "Q", 
          "K": "K",
          "A": "A",
          // Trick variations
          "1 tricks": "1 El",
          "2 tricks": "2 El",
          "3 tricks": "3 El",
          "4 tricks": "4 El",
          "5 tricks": "5 El",
          "6 tricks": "6 El",
          "7 tricks": "7 El",
          "8 tricks": "8 El",
          "9 tricks": "9 El",
          "10 tricks": "10 El",
          "11 tricks": "11 El",
          "12 tricks": "12 El",
          "13 tricks": "13 El",
          // Other common hands
          "NO_TRICKS": "El Almaz",
          "NO_HEARTS": "Kupa Almaz",
          "NO_MEN": "Erkek Almaz",
          "NO_WOMEN": "Kız Almaz", 
          "NO_HANDS": "El Almaz",
          "LAST_TWO": "Son İki",
          "RIFKI": "Rıfkı"
        }
      },
      // Punishments
      punishments: {
        title: "Cezalar",
        noPunishments: "Henüz ceza yok",
        punishment: "Ceza",
        reason: "Sebep"
      },
      // Notes
      notes: {
        title: "Notlar",
        addNote: "Not ekle",
        saveNote: "Notu kaydet",
        deleteNote: "Notu sil",
        noNotes: "Henüz not yok",
        messages: "Mesajlar",
        typeYourMessage: "Mesajınızı yazın...",
        sendMessage: "Mesaj gönder",
        noMessagesYet: "Henüz mesaj yok"
      },
      // Previous Taker
      previousTaker: {
        title: "Önceki Alan",
        noPreviousTaker: "Henüz önceki alan yok"
      },
      // Share
      share: {
        inviteTitle: "Game Garden - King oyununa katıl!",
        inviteText: "Oyun odama katılmak için linke tıkla:",
        dialogTitle: "Oyun Odasını Paylaş",
        linkCopied: "Oda linki panoya kopyalandı!",
        shareError: "Oda linki paylaşılamıyor. Lütfen manuel olarak paylaş:",
        clipboardError: "Link panoya kopyalanamadı",
        shareRoom: "Odayı Paylaş"
      },
      // Common
      common: {
        yes: "Evet",
        no: "Hayır",
        ok: "Tamam",
        cancel: "İptal",
        save: "Kaydet",
        delete: "Sil",
        edit: "Düzenle",
        close: "Kapat",
        loading: "Yükleniyor...",
        error: "Hata",
        success: "Başarılı",
        warning: "Uyarı",
        info: "Bilgi",
        language: "Dil"
      }
    }
  },
  en: {
    translation: {
      // Login screen
      login: {
        title: "King Card Game",
        subtitle: "Enter the royal realm of strategy",
        username: "Username",
        usernamePlaceholder: "Enter your username",
        roomName: "Room Name",
        roomPlaceholder: "Enter room name",
        singlePlayerMode: "Single Player Mode",
        singlePlayerDescription: "Play against AI opponents",
        joinGame: "Join Game",
        connecting: "Connecting...",
        gameRules: "Game Rules",
        // Authentication step
        chooseHowToContinue: "Choose how you'd like to continue",
        loginWithGoogle: "Login with Google",
        signingIn: "Signing in...",
        continueAsGuest: "Continue as Guest",
        googleLoginSavesProgress: "Google login saves your progress and preferences",
        back: "← Back",
        // Game mode selection
        singlePlayer: "🎮 Single Player",
        multiplayer: "👥 Multiplayer",
        // Room selection
        enterRoomName: "Enter a room name to join or create",
        enterRoomNamePlaceholder: "Enter room name",
        joining: "Joining...",
        joinRoom: "Join Room",
        // Username modal
        chooseYourUsername: "Choose Your Username",
        enterDisplayName: "Enter a display name for the game",
        enterYourUsername: "Enter your username",
        cancel: "Cancel",
        rules: {
          rule1: "• 4 players compete in this strategic card game",
          rule2: "• Play multiplayer with friends or single player vs AI",
          rule3: "• Bid on hands and avoid penalty cards",
          rule4: "• Win 10+ tricks to achieve \"King\" and end the game",
          rule5: "• The player with the highest score wins"
        },
        debugInfo: "Debug Info",
        debugServerMessage: "Make sure the backend server is running on port 8080",
        connectionStatus: {
          connecting: "Connecting to server...",
          connected: "Connected ✓",
          error: "Connection failed ✗",
          disconnected: "Disconnected"
        }
      },
      // Game Board
      game: {
        yourCards: "Your Cards",
        middleCards: "Cards in the Middle",
        currentPlayer: "Current Player",
        waitingForOtherPlayers: "Waiting for other players",
        selectCard: "Select card",
        playCard: "Play card",
        yourTurn: "Your turn",
        gameEnded: "Game ended",
        winner: "Winner",
        playerLeft: "Player left",
        reconnecting: "Reconnecting...",
        cardsWillAppearHere: "Cards will appear here",
        whenPlayersMove: "when players make their moves",
        yourTurnToPlay: "🎯 Your turn to play a card!",
        waitingForPlayer: "⏳ Waiting for {playerName} to play...",
        hiddenCard: "Hidden Card"
      },
      // Score Board
      score: {
        title: "Scores",
        player: "Player",
        score: "Score",
        round: "Round",
        totalScore: "Total Score",
        scoreboard: "Scoreboard",
        chooseYourHand: "Choose Your Hand",
        previewAvailableHands: "Preview Available Hands",
        currentHand: "Current Hand",
        positive: "positive",
        negative: "negative",
        pts: "pts",
        noScoresYet: "No scores yet",
        scoresWillAppear: "Scores will appear during the game",
        totalPlayers: "Total Players",
        highestScore: "Highest Score"
      },
      // Available Hands
      hands: {
        title: "Available Hands",
        selectHand: "Select hand",
        noHands: "No hands available", 
        bidding: "Bidding",
        selectedHand: "Selected hand",
        waitingForTurn: "⏳ Waiting for your turn to choose",
        chooseHand: "Choose Hand",
        yourTurn: "Your turn",
        previewOnly: "Preview only",
        waitingForTurnDots: "Waiting for turn...",
        availableHands: "Available Hands",
        chooseYourHand: "🎯 Choose your hand!",
        noHandsAvailable: "No hands available",
        handsWillAppear: "Hands will appear when it's time to choose",
        waitingForTurnToChoose: "⏳ Waiting for your turn to choose",
        // Specific hand names
        handNames: {
          // Positive hands (tricks)
          "1_tricks": "1 Trick",
          "2_tricks": "2 Tricks",
          "3_tricks": "3 Tricks", 
          "4_tricks": "4 Tricks",
          "5_tricks": "5 Tricks",
          "6_tricks": "6 Tricks",
          "7_tricks": "7 Tricks",
          "8_tricks": "8 Tricks",
          "9_tricks": "9 Tricks",
          "10_tricks": "10 Tricks",
          "11_tricks": "11 Tricks",
          "12_tricks": "12 Tricks",
          "13_tricks": "13 Tricks",
          "king": "King",
          "kral": "King",
          // Punishment hands
          "rifki": "Avoid King of Hearts",
          "no_hands": "Avoid Tricks",
          "no_men": "Avoid Jacks/Kings",
          "no_women": "Avoid Queens",
          "no_hearts": "Avoid Hearts",
          "no_tricks": "Avoid Tricks",
          "last_two": "Avoid Last Two Tricks",
          // Card suits and values
          "CLUBS": "Clubs",
          "DIAMONDS": "Diamonds",
          "HEARTS": "Hearts", 
          "SPADES": "Spades",
          "clubs": "Clubs",
          "diamonds": "Diamonds",
          "hearts": "Hearts",
          "spades": "Spades",
          // Additional card values that might appear
          "J": "J",
          "Q": "Q", 
          "K": "K",
          "A": "A",
          // Trick variations
          "1 tricks": "1 Trick",
          "2 tricks": "2 Tricks",
          "3 tricks": "3 Tricks",
          "4 tricks": "4 Tricks",
          "5 tricks": "5 Tricks",
          "6 tricks": "6 Tricks",
          "7 tricks": "7 Tricks",
          "8 tricks": "8 Tricks",
          "9 tricks": "9 Tricks",
          "10 tricks": "10 Tricks",
          "11 tricks": "11 Tricks",
          "12 tricks": "12 Tricks",
          "13 tricks": "13 Tricks",
          // Other common hands
          "NO_TRICKS": "Avoid Tricks",
          "NO_HEARTS": "Avoid Hearts",
          "NO_MEN": "Avoid Jacks/Kings",
          "NO_WOMEN": "Avoid Queens",
          "NO_HANDS": "Avoid Tricks", 
          "LAST_TWO": "Avoid Last Two Tricks",
          "RIFKI": "Avoid King of Hearts"
        }
      },
      // Punishments
      punishments: {
        title: "Punishments",
        noPunishments: "No punishments yet",
        punishment: "Punishment",
        reason: "Reason"
      },
      // Notes
      notes: {
        title: "Notes",
        addNote: "Add note",
        saveNote: "Save note",
        deleteNote: "Delete note",
        noNotes: "No notes yet",
        messages: "Messages",
        typeYourMessage: "Type your message...",
        sendMessage: "Send message",
        noMessagesYet: "No messages yet"
      },
      // Previous Taker
      previousTaker: {
        title: "Previous Taker",
        noPreviousTaker: "No previous taker yet"
      },
      // Share
      share: {
        inviteTitle: "Join my Game Garden - King of Hearts!",
        inviteText: "Click the link to join my game room:",
        dialogTitle: "Share Game Room",
        linkCopied: "Room link copied to clipboard!",
        shareError: "Unable to share room link. Please share manually:",
        clipboardError: "Unable to copy link to clipboard",
        shareRoom: "Share Room"
      },
      // Common
      common: {
        yes: "Yes",
        no: "No",
        ok: "OK",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        edit: "Edit",
        close: "Close",
        loading: "Loading...",
        error: "Error",
        success: "Success",
        warning: "Warning",
        info: "Info",
        language: "Language"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr', // Default to Turkish
    fallbackLng: 'tr',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;